export default "__VITE_ASSET__Cy3fyPzP__"